import React, { useState } from 'react';
import { siteCopy } from '../../content/siteCopy';

const Faq = () => {
  const { faq } = siteCopy.aboutUs;
  const [activeId, setActiveId] = useState(faq.items[0]?.id ?? '');

  const handleToggle = (id) => {
    setActiveId(activeId === id ? '' : id);
  };

  const leftColumn = faq.items.slice(0, Math.ceil(faq.items.length / 2));
  const rightColumn = faq.items.slice(Math.ceil(faq.items.length / 2));

  const renderColumn = (items) =>
    items.map((item) => (
      <div className="card" key={item.id}>
        <div className="card-header" id={item.heading}>
          <h5 className="mb-0">
            <button
              className={`btn btn-link btn-block text-left ${activeId === item.id ? '' : 'collapsed'}`}
              type="button"
              onClick={() => handleToggle(item.id)}
              aria-expanded={activeId === item.id}
              aria-controls={item.id}
            >
              {item.question}
              <span className="icons">
                {activeId === item.id ? (
                  <i className="icofont-minus" />
                ) : (
                  <i className="icofont-plus" />
                )}
              </span>
            </button>
          </h5>
        </div>
        <div
          id={item.id}
          className={`collapse ${activeId === item.id ? 'show' : ''}`}
          aria-labelledby={item.heading}
          data-parent="#accordionExample"
        >
          <div className="card-body">{item.answer}</div>
        </div>
      </div>
    ));

  return (
    <>
      <section className="row_am faq_section" id="faqsec">
        <div className="container">
          <div className="section_title" data-aos="fade-up" data-aos-duration={1500}>
            <span className="title_badge">{faq.badge}</span>
            <h2>{faq.title}</h2>
          </div>
          <div className="faq_blocks" data-aos="fade-up" data-aos-duration={1500}>
            <div className="accordion" id="accordionExample">
              <div className="row">
                <div className="col-md-6">{renderColumn(leftColumn)}</div>
                <div className="col-md-6">{renderColumn(rightColumn)}</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Faq;
